import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { authInterceptor } from './Services/auth.interceptor';
import { logInterceptor } from './Services/log.interceptor';
import { apiErrorInterceptor } from './Services/api-error.interceptor';

import { routes } from './app.routes';
import { EtatService } from './Services/etat';
import { Authentification } from './Services/authentification';

/**
 * Factory APP_INITIALIZER : charge la liste des parcs et sélectionne le premier
 * (parc global en tête, puis ordre alphabétique) avant que le router n'active
 * la première route. Garantit que `EtatService.parcSelectionne` est non-null
 * dès le premier rendu, y compris sur navigation directe vers une URL profonde
 * (ex. /installation/1076). Les erreurs réseau sont silencieuses : l'app
 * démarre quand même avec aucun parc sélectionné.
 */
function initialiserParc(auth: Authentification, etat: EtatService): () => Promise<void> {
  return async () => {
    const token = await auth.getToken();
    if (!token) return;
    await etat.chargerParcs();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withXhr(), withInterceptors([apiErrorInterceptor, authInterceptor, logInterceptor])),
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-symbols-outlined' } },
    {
      provide: APP_INITIALIZER,
      useFactory: initialiserParc,
      deps: [Authentification, EtatService],
      multi: true,
    },
  ],
};
